import React from "react";
import LandingPageLayout from "@/components/LandingPageLayout";

export default function CairoAirportTransfer() {
  return (
    <LandingPageLayout translationKey="cairoAirport" />
  );
}
